/* ============================================================
   color-picker-modal.js
   Plaatsen in: /assets/color-picker-modal.js
   Laden via: {{ 'color-picker-modal.js' | asset_url | script_tag }}
   in theme.liquid of aan het einde van main-product.liquid
   ============================================================ */

(function () {
  'use strict';

  // ─────────────────────────────────────────────
  //  KLEURENDATA
  // ─────────────────────────────────────────────

  const RAL = [
    { code:"RAL 1000", name:"Groenbeige", hex:"#CDBA88" },
    { code:"RAL 1001", name:"Beige", hex:"#D2AA6D" },
    { code:"RAL 1002", name:"Zandgeel", hex:"#D8A723" },
    { code:"RAL 1003", name:"Signaalgeel", hex:"#F7A600" },
    { code:"RAL 1004", name:"Goudgeel", hex:"#E49E00" },
    { code:"RAL 1005", name:"Honinggeel", hex:"#CB8F00" },
    { code:"RAL 1006", name:"Maisgeel", hex:"#E29000" },
    { code:"RAL 1007", name:"Narcissengeel", hex:"#E88C00" },
    { code:"RAL 1011", name:"Bruingeel", hex:"#AF8A38" },
    { code:"RAL 1012", name:"Citroengeel", hex:"#D9C022" },
    { code:"RAL 1013", name:"Parelwit", hex:"#E9E5CE" },
    { code:"RAL 1014", name:"Ivoor", hex:"#DFD6AF" },
    { code:"RAL 1015", name:"Lichtivoor", hex:"#E9DCCA" },
    { code:"RAL 1016", name:"Zwaveligeel", hex:"#EAE132" },
    { code:"RAL 1017", name:"Safraan", hex:"#F5A325" },
    { code:"RAL 1018", name:"Zinkgeel", hex:"#FACA31" },
    { code:"RAL 1019", name:"Grijsbeige", hex:"#A99580" },
    { code:"RAL 1020", name:"Olijfgeel", hex:"#99892A" },
    { code:"RAL 1021", name:"Koolzaadgeel", hex:"#F3B200" },
    { code:"RAL 1023", name:"Verkeersgeel", hex:"#F5AF00" },
    { code:"RAL 1024", name:"Okergeel", hex:"#B89050" },
    { code:"RAL 1026", name:"Briljantgeel", hex:"#FFFF00" },
    { code:"RAL 1027", name:"Currygeel", hex:"#9D8135" },
    { code:"RAL 1028", name:"Meloengeel", hex:"#F4A020" },
    { code:"RAL 1032", name:"Breemgeel", hex:"#E0A000" },
    { code:"RAL 1033", name:"Dahliageel", hex:"#F4A428" },
    { code:"RAL 1034", name:"Pastelgeel", hex:"#EBA328" },
    { code:"RAL 1037", name:"Zonnegeel", hex:"#F49200" },
    { code:"RAL 2000", name:"Geelrood", hex:"#E75B12" },
    { code:"RAL 2001", name:"Roodoranje", hex:"#BE4E20" },
    { code:"RAL 2002", name:"Bloedrood", hex:"#C63927" },
    { code:"RAL 2003", name:"Pasteloranje", hex:"#FA7829" },
    { code:"RAL 2004", name:"Puuroranje", hex:"#E55612" },
    { code:"RAL 2008", name:"Helderoranjerood", hex:"#F3711B" },
    { code:"RAL 2009", name:"Verkeersoranje", hex:"#E55B17" },
    { code:"RAL 2010", name:"Signaaloranje", hex:"#D5531A" },
    { code:"RAL 2011", name:"Dieporanje", hex:"#EC7C25" },
    { code:"RAL 2012", name:"Zalmoranje", hex:"#D4652F" },
    { code:"RAL 3000", name:"Vuurrood", hex:"#AB2524" },
    { code:"RAL 3001", name:"Signaalrood", hex:"#A52019" },
    { code:"RAL 3002", name:"Karmijnrood", hex:"#A2231D" },
    { code:"RAL 3003", name:"Robijnrood", hex:"#8D1D2C" },
    { code:"RAL 3004", name:"Purperrood", hex:"#701F29" },
    { code:"RAL 3005", name:"Wijnrood", hex:"#5E2028" },
    { code:"RAL 3007", name:"Zwartgroen", hex:"#402225" },
    { code:"RAL 3009", name:"Oxiderood", hex:"#703731" },
    { code:"RAL 3011", name:"Bruinrood", hex:"#7E292C" },
    { code:"RAL 3012", name:"Beigerood", hex:"#CB8D73" },
    { code:"RAL 3013", name:"Tomaatrood", hex:"#9C322E" },
    { code:"RAL 3014", name:"Antiekrood", hex:"#D36E70" },
    { code:"RAL 3015", name:"Lichtrood", hex:"#E8A0A0" },
    { code:"RAL 3016", name:"Koraalrood", hex:"#AB3B3A" },
    { code:"RAL 3017", name:"Roosrood", hex:"#D63244" },
    { code:"RAL 3018", name:"Aardbeirood", hex:"#D53032" },
    { code:"RAL 3020", name:"Verkeersrood", hex:"#C7161E" },
    { code:"RAL 3022", name:"Zalmrood", hex:"#D56D56" },
    { code:"RAL 3027", name:"Frambozenrood", hex:"#B42041" },
    { code:"RAL 3028", name:"Puur rood", hex:"#CC2C24" },
    { code:"RAL 3031", name:"Oriëntrood", hex:"#A63437" },
    { code:"RAL 4001", name:"Roodlila", hex:"#8A5A80" },
    { code:"RAL 4002", name:"Roodviolet", hex:"#933D50" },
    { code:"RAL 4003", name:"Heidepurper", hex:"#D15B8F" },
    { code:"RAL 4004", name:"Bordeauxviolet", hex:"#6E1844" },
    { code:"RAL 4005", name:"Blauwlila", hex:"#7A6B99" },
    { code:"RAL 4006", name:"Verkeerspurper", hex:"#922B3E" },
    { code:"RAL 4007", name:"Purperviolet", hex:"#4A203C" },
    { code:"RAL 4008", name:"Signaalpurper", hex:"#904684" },
    { code:"RAL 4009", name:"Pastelpurper", hex:"#A38995" },
    { code:"RAL 4010", name:"Telemagenta", hex:"#CF3476" },
    { code:"RAL 5000", name:"Violetblauw", hex:"#31507B" },
    { code:"RAL 5001", name:"Groenblauw", hex:"#1F4764" },
    { code:"RAL 5002", name:"Ultramarijnblauw", hex:"#20296F" },
    { code:"RAL 5003", name:"Saffierblauw", hex:"#1D3557" },
    { code:"RAL 5004", name:"Zwartblauw", hex:"#18233D" },
    { code:"RAL 5005", name:"Signaalblauw", hex:"#1F447C" },
    { code:"RAL 5007", name:"Briljantblauw", hex:"#3D6FA2" },
    { code:"RAL 5008", name:"Grijsblauw", hex:"#35495E" },
    { code:"RAL 5009", name:"Azuurblauw", hex:"#2B5F8E" },
    { code:"RAL 5010", name:"Gentiaanblauw", hex:"#1B4484" },
    { code:"RAL 5011", name:"Staalblauw", hex:"#1D3149" },
    { code:"RAL 5012", name:"Lichtblauw", hex:"#3481B8" },
    { code:"RAL 5013", name:"Kobaltblauw", hex:"#232C60" },
    { code:"RAL 5014", name:"Duifblauw", hex:"#627EA0" },
    { code:"RAL 5015", name:"Hemelblauw", hex:"#2278B1" },
    { code:"RAL 5017", name:"Verkeersblauw", hex:"#0E518D" },
    { code:"RAL 5018", name:"Turkoois blauw", hex:"#21888F" },
    { code:"RAL 5019", name:"Capriblauw", hex:"#1A5784" },
    { code:"RAL 5020", name:"Oceaanblauw", hex:"#0F3E4A" },
    { code:"RAL 5021", name:"Waterblauw", hex:"#1B7490" },
    { code:"RAL 5022", name:"Nachtblauw", hex:"#222D5A" },
    { code:"RAL 5023", name:"Verkeersblauw 2", hex:"#466285" },
    { code:"RAL 5024", name:"Pastelblauw", hex:"#5B7FA6" },
    { code:"RAL 6000", name:"Patinagroen", hex:"#3E7860" },
    { code:"RAL 6001", name:"Smaragdgroen", hex:"#2E7731" },
    { code:"RAL 6002", name:"Bladergroen", hex:"#326720" },
    { code:"RAL 6003", name:"Olijfgroen", hex:"#4B5828" },
    { code:"RAL 6004", name:"Blauwgroen", hex:"#1C5A4B" },
    { code:"RAL 6005", name:"Mosgroen", hex:"#1C5739" },
    { code:"RAL 6006", name:"Grijsolijf", hex:"#3C4121" },
    { code:"RAL 6007", name:"Flessegroen", hex:"#2D3A1F" },
    { code:"RAL 6008", name:"Bruingroen", hex:"#35382A" },
    { code:"RAL 6009", name:"Dennegroen", hex:"#2B3D2B" },
    { code:"RAL 6010", name:"Grasgroen", hex:"#41703A" },
    { code:"RAL 6011", name:"Resedagroen", hex:"#657B59" },
    { code:"RAL 6012", name:"Zwartgroen 2", hex:"#2C3B30" },
    { code:"RAL 6013", name:"Rietgroen", hex:"#87846A" },
    { code:"RAL 6016", name:"Turkooisgroen", hex:"#1B6645" },
    { code:"RAL 6017", name:"Maigroen", hex:"#457839" },
    { code:"RAL 6018", name:"Geelgroen", hex:"#578835" },
    { code:"RAL 6019", name:"Witgroen", hex:"#B9CAAD" },
    { code:"RAL 6021", name:"Lichtgroen", hex:"#8E9E7E" },
    { code:"RAL 6024", name:"Verkeersgroen", hex:"#248B43" },
    { code:"RAL 6025", name:"Varengroen", hex:"#5D7B3C" },
    { code:"RAL 6026", name:"Opaakgroen", hex:"#1B6440" },
    { code:"RAL 6027", name:"Lichtgroen 2", hex:"#82C9B4" },
    { code:"RAL 6028", name:"Dennegroen 2", hex:"#31683C" },
    { code:"RAL 6029", name:"Mintgroen", hex:"#247B48" },
    { code:"RAL 6032", name:"Signaalgroen", hex:"#2D8B4A" },
    { code:"RAL 6033", name:"Mintturkoois", hex:"#45888B" },
    { code:"RAL 6034", name:"Pastelturkoois", hex:"#7FB0B2" },
    { code:"RAL 6037", name:"Puurgroen", hex:"#00883A" },
    { code:"RAL 7000", name:"Kwartsgrijs", hex:"#7C8C8B" },
    { code:"RAL 7001", name:"Zilvergrijs", hex:"#8D9FA0" },
    { code:"RAL 7002", name:"Olijfgrijs", hex:"#857D6B" },
    { code:"RAL 7003", name:"Mosgrijs", hex:"#787866" },
    { code:"RAL 7004", name:"Signaalgrijs", hex:"#9B9B9B" },
    { code:"RAL 7005", name:"Muisgrijs", hex:"#6C7B72" },
    { code:"RAL 7006", name:"Beigegrijs", hex:"#76705C" },
    { code:"RAL 7008", name:"Khakigrijs", hex:"#7A6C4A" },
    { code:"RAL 7009", name:"Groengrijs", hex:"#606155" },
    { code:"RAL 7010", name:"Leigrijs", hex:"#5B6259" },
    { code:"RAL 7011", name:"IJzergrijs", hex:"#525B62" },
    { code:"RAL 7012", name:"Basaltgrijs", hex:"#595E62" },
    { code:"RAL 7013", name:"Bruingrijs", hex:"#5D5B50" },
    { code:"RAL 7015", name:"Leigrijs 2", hex:"#494D57" },
    { code:"RAL 7016", name:"Antracietgrijs", hex:"#3B3F45" },
    { code:"RAL 7021", name:"Zwartgrijs", hex:"#2E3234" },
    { code:"RAL 7022", name:"Ombergrijs", hex:"#4B4D46" },
    { code:"RAL 7023", name:"Betongrijs", hex:"#7E8078" },
    { code:"RAL 7024", name:"Grafietgrijs", hex:"#464A52" },
    { code:"RAL 7026", name:"Granietgrijs", hex:"#40484B" },
    { code:"RAL 7030", name:"Steengrijs", hex:"#8F8F85" },
    { code:"RAL 7031", name:"Blauwgrijs", hex:"#5F6E72" },
    { code:"RAL 7032", name:"Kiezelgrijs", hex:"#B9B3A3" },
    { code:"RAL 7033", name:"Cementgrijs", hex:"#818977" },
    { code:"RAL 7034", name:"Geelgrijs", hex:"#91896E" },
    { code:"RAL 7035", name:"Lichtgrijs", hex:"#C5C8C4" },
    { code:"RAL 7036", name:"Platingrijs", hex:"#9A9693" },
    { code:"RAL 7037", name:"Stofgrijs", hex:"#7B7F80" },
    { code:"RAL 7038", name:"Agaatgrijs", hex:"#B4B5AE" },
    { code:"RAL 7039", name:"Kwartsgrijs 2", hex:"#6B6960" },
    { code:"RAL 7040", name:"Venstergrijs", hex:"#9C9E9B" },
    { code:"RAL 7042", name:"Verkeersgrijs A", hex:"#909386" },
    { code:"RAL 7043", name:"Verkeersgrijs B", hex:"#4F5250" },
    { code:"RAL 7044", name:"Zijdegrijs", hex:"#BDBDB3" },
    { code:"RAL 7045", name:"Telegrijs 1", hex:"#909192" },
    { code:"RAL 7046", name:"Telegrijs 2", hex:"#82898C" },
    { code:"RAL 7047", name:"Telegrijs 4", hex:"#C5C6C4" },
    { code:"RAL 8000", name:"Groenbruin", hex:"#8D7147" },
    { code:"RAL 8001", name:"Okrabruin", hex:"#9D622B" },
    { code:"RAL 8002", name:"Signaalbruin", hex:"#7B4833" },
    { code:"RAL 8003", name:"Leembruin", hex:"#7B5030" },
    { code:"RAL 8004", name:"Koperbruin", hex:"#8D4931" },
    { code:"RAL 8007", name:"Hertbruin", hex:"#704027" },
    { code:"RAL 8008", name:"Olijfbruin", hex:"#7A4B21" },
    { code:"RAL 8011", name:"Nootbruin", hex:"#5B3120" },
    { code:"RAL 8012", name:"Roodbruin", hex:"#673527" },
    { code:"RAL 8014", name:"Sepiabruin", hex:"#4A3324" },
    { code:"RAL 8015", name:"Kastanjebruin", hex:"#633A2E" },
    { code:"RAL 8016", name:"Mahonibruin", hex:"#4C2B20" },
    { code:"RAL 8017", name:"Chocoladebruin", hex:"#432221" },
    { code:"RAL 8019", name:"Grijsbruin", hex:"#3D3028" },
    { code:"RAL 8022", name:"Zwartbruin", hex:"#1D1714" },
    { code:"RAL 8023", name:"Oranje bruin", hex:"#935228" },
    { code:"RAL 8024", name:"Beige bruin", hex:"#7D5533" },
    { code:"RAL 8025", name:"Lichtbruin", hex:"#8A6242" },
    { code:"RAL 8028", name:"Terrabruin", hex:"#4F3829" },
    { code:"RAL 9001", name:"Crèmewit", hex:"#EEE8D7" },
    { code:"RAL 9002", name:"Grijswit", hex:"#E1DDD4" },
    { code:"RAL 9003", name:"Signaalblanc", hex:"#F2F1EC" },
    { code:"RAL 9004", name:"Signaalzwart", hex:"#2B2B2C" },
    { code:"RAL 9005", name:"Gitzwart", hex:"#0E0E10" },
    { code:"RAL 9006", name:"Wit-aluminium", hex:"#A6A9AA" },
    { code:"RAL 9007", name:"Grijs-aluminium", hex:"#8F8F8C" },
    { code:"RAL 9010", name:"Zuiverwit", hex:"#F6F4EF" },
    { code:"RAL 9011", name:"Grafietblanc", hex:"#272829" },
    { code:"RAL 9016", name:"Verkeerswit", hex:"#F7F9F5" },
    { code:"RAL 9017", name:"Verkeersswart", hex:"#252523" },
    { code:"RAL 9018", name:"Papyruswit", hex:"#D9D6CF" },
  ];

  // ─── Copperant kleuren ───
  const COPPERANT_MUCHA = [
    // Lente
    { code:"CMC 425", name:"Lei blauw",           hex:"#6A7E96", sub:"Lente" },
    { code:"CMC 305", name:"Zacht beige",          hex:"#D8C8B0", sub:"Lente" },
    { code:"CMC 725", name:"Fris geel",            hex:"#E8D87A", sub:"Lente" },
    { code:"CMC 705", name:"Room wit",             hex:"#F0E8D0", sub:"Lente" },
    { code:"CMC 225", name:"Licht olijf groen",    hex:"#A0B070", sub:"Lente" },
    { code:"CMC 125", name:"Antiek beige",         hex:"#C8B090", sub:"Lente" },
    { code:"CMC 605", name:"Pleister grijs",       hex:"#C0B8A8", sub:"Lente" },
    { code:"CMC 515", name:"Zacht roze",           hex:"#E0B8B0", sub:"Lente" },
    { code:"CMC 635", name:"Muis grijs",           hex:"#A0988C", sub:"Lente" },
    { code:"CMC 525", name:"Oud roze",             hex:"#C88090", sub:"Lente" },
    { code:"CMC 405", name:"Krijt blauw",          hex:"#8090A8", sub:"Lente" },
    { code:"CMC 745", name:"Oud geel",             hex:"#D8C880", sub:"Lente" },
    // Zomer
    { code:"CMC 165", name:"Hazelnoot bruin",      hex:"#8B6040", sub:"Zomer" },
    { code:"CMC 335", name:"Avond rood",           hex:"#9B3838", sub:"Zomer" },
    { code:"CMC 445", name:"Azuur blauw",          hex:"#4878A8", sub:"Zomer" },
    { code:"CMC 215", name:"Tarwe groen",          hex:"#98A868", sub:"Zomer" },
    { code:"CMC 255", name:"Olijf groen",          hex:"#708050", sub:"Zomer" },
    { code:"CMC 645", name:"Amber grijs",          hex:"#A09880", sub:"Zomer" },
    { code:"CMC 145", name:"Mergel geel",          hex:"#D8C878", sub:"Zomer" },
    { code:"CMC 415", name:"Hemels blauw",         hex:"#5888B0", sub:"Zomer" },
    { code:"CMC 465", name:"Klassiek blauw",       hex:"#3858A0", sub:"Zomer" },
    { code:"CMC 155", name:"Amandel bruin",        hex:"#A07858", sub:"Zomer" },
    { code:"CMC 205", name:"Zandsteen",            hex:"#C8B888", sub:"Zomer" },
    { code:"CMC 735", name:"Zand wit",             hex:"#EDE8D8", sub:"Zomer" },
    // Herfst
    { code:"CMC 115", name:"Molen geel",           hex:"#E8C040", sub:"Herfst" },
    { code:"CMC 665", name:"Mokka",                hex:"#6A4830", sub:"Herfst" },
    { code:"CMC 455", name:"Vaal turquoise",       hex:"#7090A0", sub:"Herfst" },
    { code:"CMC 265", name:"Hollands groen",       hex:"#4A7050", sub:"Herfst" },
    { code:"CMC 135", name:"Bentheimer geel",      hex:"#D8C068", sub:"Herfst" },
    { code:"CMC 245", name:"Koper groen",          hex:"#6A9078", sub:"Herfst" },
    { code:"CMC 535", name:"Spaans rood",          hex:"#9B3028", sub:"Herfst" },
    { code:"CMC 495", name:"Hardsteen grijs",      hex:"#808880", sub:"Herfst" },
    { code:"CMC 105", name:"Perkament wit",        hex:"#E8E0C8", sub:"Herfst" },
    { code:"CMC 315", name:"Zalm roze",            hex:"#D89078", sub:"Herfst" },
    { code:"CMC 325", name:"Toscaans terracotta",  hex:"#C06848", sub:"Herfst" },
    { code:"CMC 345", name:"Havana bruin",         hex:"#7A5030", sub:"Herfst" },
    // Winter
    { code:"CMC 715", name:"Winters wit",          hex:"#F2F0EB", sub:"Winter" },
    { code:"CMC 615", name:"Grijsblauw",           hex:"#7A90A0", sub:"Winter" },
    { code:"CMC 545", name:"Velours rood",         hex:"#8B3038", sub:"Winter" },
    { code:"CMC 505", name:"Iris blauw",           hex:"#4A5888", sub:"Winter" },
    { code:"CMC 655", name:"Zacht grijs",          hex:"#C0B8B0", sub:"Winter" },
    { code:"CMC 555", name:"Grijsbruin",           hex:"#8A7868", sub:"Winter" },
    { code:"CMC 175", name:"Chocolade bruin",      hex:"#4A2818", sub:"Winter" },
    { code:"CMC 435", name:"Klassiek bruin",       hex:"#6A4828", sub:"Winter" },
    { code:"CMC 625", name:"Oud blauwgrijs",       hex:"#6A7880", sub:"Winter" },
    { code:"CMC 235", name:"Graniet grijs",        hex:"#808078", sub:"Winter" },
    { code:"CMC 485", name:"Antiek groengrijs",    hex:"#6A7868", sub:"Winter" },
    { code:"CMC 486", name:"Diep blauwgrijs",      hex:"#4A5868", sub:"Winter" },
  ];

  const COPPERANT_TRAD = [
    { code:"1",  name:"Mergel wit",         hex:"#F0ECE0" },
    { code:"2",  name:"Cement grijs",       hex:"#B0A898" },
    { code:"3",  name:"Klassiek grijs",     hex:"#8A8880" },
    { code:"4",  name:"Drents bruin",       hex:"#6B4828" },
    { code:"5",  name:"Zweeds rood",        hex:"#8B3028" },
    { code:"6",  name:"Engels rood",        hex:"#7B2820" },
    { code:"7",  name:"Pruisisch blauw",    hex:"#1A3A5C" },
    { code:"8",  name:"Gelders blauw",      hex:"#2A4A6C" },
    { code:"9",  name:"Standgroen",         hex:"#3A5830" },
    { code:"10", name:"Monumenten-groen",   hex:"#2A4828" },
    { code:"11", name:"Grachten-groen",     hex:"#3A5840" },
    { code:"12", name:"Klassiek zwart",     hex:"#1A1A1A" },
  ];

  const COPPERANT_WIT = [
    { code:"CMC 761", name:"Delfts wit",    hex:"#F0ECDC" },
    { code:"CMC 713", name:"Zacht wit",     hex:"#F5F0E8" },
    { code:"CMC 737", name:"Sneeuw wit",    hex:"#F8F8F5" },
    { code:"CMC 755", name:"Kokos wit",     hex:"#F0E8D8" },
    { code:"CMC 727", name:"Lente wit",     hex:"#F0ECE0" },
    { code:"CMC 721", name:"Melk wit",      hex:"#F5F0EC" },
    { code:"CMC 732", name:"Beige wit",     hex:"#EDE8D8" },
    { code:"CMC 736", name:"Natuur wit",    hex:"#ECE8D8" },
    { code:"CMC 765", name:"Ivoor wit",     hex:"#F0E8CC" },
    { code:"CMC 758", name:"Robijn wit",    hex:"#F0E8E0" },
    { code:"CMC 743", name:"Zee wit",       hex:"#E8EDF0" },
    { code:"CMC 718", name:"Strand wit",    hex:"#EDE8D0" },
  ];

  const COPPERANT_HOUT = [
    { code:"No. 00", name:"White Wash",     hex:"#E8D8C0" },
    { code:"No. 13", name:"Zwart",          hex:"#1A1A1A" },
    { code:"No. 14", name:"Blank",          hex:"#D4B870" },
    { code:"No. 15", name:"Palissander",    hex:"#4A2418" },
    { code:"No. 16", name:"Iroko",          hex:"#9B7040" },
    { code:"No. 17", name:"Grenen",         hex:"#C8A060" },
    { code:"No. 19", name:"Ebben",          hex:"#2C1810" },
    { code:"No. 20", name:"Teak",           hex:"#9B6B30" },
    { code:"No. 21", name:"Noten",          hex:"#5A3820" },
    { code:"No. 22", name:"Eiken",          hex:"#8B6040" },
    { code:"No. 25", name:"Afzelia",        hex:"#B87840" },
    { code:"No. 26", name:"Donker Eiken",   hex:"#6B4423" },
    { code:"No. 29", name:"Redwood",        hex:"#8B3020" },
    { code:"No. 45", name:"Mahonie",        hex:"#6B2C20" },
  ];

  // ─── KEIM kleuren ───
  const KEIM_AVANTGARDE = [
    { code:"KEIM-016", hex:"#E0D1BC" }, { code:"KEIM-075", hex:"#9E8682" }, { code:"KEIM-140", hex:"#C1C9CE" },
    { code:"KEIM-018", hex:"#DAC6AE" }, { code:"KEIM-076", hex:"#988B77" }, { code:"KEIM-141", hex:"#B0BBC4" },
    { code:"KEIM-023", hex:"#C3AA8D" }, { code:"KEIM-077", hex:"#9A776A" }, { code:"KEIM-142", hex:"#A4BCD3" },
    { code:"KEIM-030", hex:"#D8D2C6" }, { code:"KEIM-079", hex:"#7CA0AF" }, { code:"KEIM-159", hex:"#E1B27B" },
    { code:"KEIM-031", hex:"#D4CEC3" }, { code:"KEIM-092", hex:"#C9CEC2" }, { code:"KEIM-168", hex:"#A4BA7A" },
    { code:"KEIM-032", hex:"#BDB7AF" }, { code:"KEIM-094", hex:"#8198A0" }, { code:"KEIM-176", hex:"#568F8D" },
    { code:"KEIM-033", hex:"#AFA193" }, { code:"KEIM-095", hex:"#A67468" }, { code:"KEIM-184", hex:"#546EB3" },
    { code:"KEIM-035", hex:"#817C75" }, { code:"KEIM-096", hex:"#CCA06C" }, { code:"KEIM-190", hex:"#607092" },
    { code:"KEIM-040", hex:"#EDE5C5" }, { code:"KEIM-097", hex:"#C7ADA2" }, { code:"KEIM-195", hex:"#BC6F58" },
    { code:"KEIM-041", hex:"#EAD5A9" }, { code:"KEIM-101", hex:"#BBB79A" }, { code:"KEIM-202", hex:"#EAB280" },
    { code:"KEIM-042", hex:"#EAD495" }, { code:"KEIM-102", hex:"#CEC7B3" }, { code:"KEIM-208", hex:"#B4B49B" },
    { code:"KEIM-052", hex:"#DAAA77" }, { code:"KEIM-103", hex:"#937C5F" }, { code:"KEIM-226", hex:"#939E8C" },
    { code:"KEIM-054", hex:"#B47C5C" }, { code:"KEIM-104", hex:"#B58E75" }, { code:"KEIM-231", hex:"#B4BDD6" },
    { code:"KEIM-061", hex:"#E9D5B3" }, { code:"KEIM-105", hex:"#9A937D" }, { code:"KEIM-235", hex:"#92A1BB" },
    { code:"KEIM-062", hex:"#E9D2B0" }, { code:"KEIM-107", hex:"#BEAB8D" }, { code:"KEIM-240", hex:"#7590B0" },
    { code:"KEIM-063", hex:"#C7BCBC" }, { code:"KEIM-111", hex:"#EADDC8" }, { code:"KEIM-246", hex:"#E7DFBC" },
    { code:"KEIM-064", hex:"#D7C1BD" }, { code:"KEIM-114", hex:"#E1D9C1" }, { code:"KEIM-247", hex:"#A2B9BF" },
    { code:"KEIM-065", hex:"#E2B5A2" }, { code:"KEIM-118", hex:"#7177A6" }, { code:"KEIM-248", hex:"#C5D0A5" },
    { code:"KEIM-066", hex:"#DFAD8E" }, { code:"KEIM-121", hex:"#F0D186" }, { code:"KEIM-249", hex:"#B84339" },
    { code:"KEIM-067", hex:"#BD8B7A" }, { code:"KEIM-122", hex:"#E2B25A" },
    { code:"KEIM-069", hex:"#C9A09A" }, { code:"KEIM-124", hex:"#B17C54" },
    { code:"KEIM-070", hex:"#DBB98C" }, { code:"KEIM-131", hex:"#69835F" },
    { code:"KEIM-071", hex:"#EAE8E4" }, { code:"KEIM-133", hex:"#7C5D52" },
    { code:"KEIM-072", hex:"#E0B888" }, { code:"KEIM-138", hex:"#C88558" },
  ].map(c => ({ ...c, name: c.code }));

  const KEIM_PALETTE_EXCLUSIV = [
    { code:"KEIM-9001", hex:"#EFE984" }, { code:"KEIM-9073", hex:"#E7CA91" }, { code:"KEIM-9125", hex:"#B9876A" },
    { code:"KEIM-9002", hex:"#DDA850" }, { code:"KEIM-9075", hex:"#EAD5A9" }, { code:"KEIM-9129", hex:"#CEA790" },
    { code:"KEIM-9003", hex:"#954737" }, { code:"KEIM-9076", hex:"#EBDDBA" }, { code:"KEIM-9132", hex:"#E0C3AC" },
    { code:"KEIM-9004", hex:"#6B644D" }, { code:"KEIM-9077", hex:"#E7DEC4" }, { code:"KEIM-9135", hex:"#E6D5C4" },
    { code:"KEIM-9005", hex:"#5C7D57" }, { code:"KEIM-9078", hex:"#EAE2CC" }, { code:"KEIM-9136", hex:"#ECDFD0" },
    { code:"KEIM-9006", hex:"#4668C5" }, { code:"KEIM-9084", hex:"#B88657" }, { code:"KEIM-9137", hex:"#ECE3D7" },
    { code:"KEIM-9007", hex:"#6B463B" }, { code:"KEIM-9087", hex:"#CCA06C" }, { code:"KEIM-9144", hex:"#B47C5C" },
    { code:"KEIM-9008", hex:"#424243" }, { code:"KEIM-9089", hex:"#DAAA77" }, { code:"KEIM-9146", hex:"#CC9273" },
    { code:"KEIM-9009", hex:"#008AB7" }, { code:"KEIM-9090", hex:"#E1B27B" }, { code:"KEIM-9149", hex:"#DFA986" },
    { code:"KEIM-9010", hex:"#894743" }, { code:"KEIM-9091", hex:"#DBB98C" }, { code:"KEIM-9153", hex:"#EAC3A5" },
    { code:"KEIM-9033", hex:"#F1D485" }, { code:"KEIM-9092", hex:"#DBC29F" }, { code:"KEIM-9154", hex:"#E9CEB7" },
    { code:"KEIM-9036", hex:"#EDDAA4" }, { code:"KEIM-9095", hex:"#E9D5B3" }, { code:"KEIM-9156", hex:"#ECDCCC" },
    { code:"KEIM-9037", hex:"#EDE1B7" }, { code:"KEIM-9096", hex:"#EADDC8" }, { code:"KEIM-9157", hex:"#E8E0D4" },
    { code:"KEIM-9038", hex:"#EDE5C5" }, { code:"KEIM-9097", hex:"#EFE2D0" }, { code:"KEIM-9162", hex:"#9F5845" },
    { code:"KEIM-9049", hex:"#DEAA5B" }, { code:"KEIM-9102", hex:"#8F6D58" }, { code:"KEIM-9164", hex:"#BC6F58" },
    { code:"KEIM-9051", hex:"#EABC78" }, { code:"KEIM-9103", hex:"#A67655" }, { code:"KEIM-9166", hex:"#D18972" },
    { code:"KEIM-9053", hex:"#EBCC9A" }, { code:"KEIM-9105", hex:"#C88558" }, { code:"KEIM-9169", hex:"#DEA48C" },
    { code:"KEIM-9055", hex:"#ECDBB6" }, { code:"KEIM-9108", hex:"#D29C6C" }, { code:"KEIM-9171", hex:"#E2B4A2" },
    { code:"KEIM-9057", hex:"#ECE0C7" }, { code:"KEIM-9110", hex:"#E0B888" }, { code:"KEIM-9174", hex:"#EACBBB" },
    { code:"KEIM-9058", hex:"#E9E2D3" }, { code:"KEIM-9112", hex:"#E9C69C" }, { code:"KEIM-9176", hex:"#EBD7CC" },
    { code:"KEIM-9064", hex:"#AE8854" }, { code:"KEIM-9115", hex:"#EBD4B3" }, { code:"KEIM-9177", hex:"#ECE2D9" },
    { code:"KEIM-9066", hex:"#C19962" }, { code:"KEIM-9117", hex:"#EDDCC5" }, { code:"KEIM-9182", hex:"#916152" },
    { code:"KEIM-9069", hex:"#D0AE78" }, { code:"KEIM-9122", hex:"#955F46" }, { code:"KEIM-9183", hex:"#A67468" },
    { code:"KEIM-9071", hex:"#E4BF7D" }, { code:"KEIM-9123", hex:"#A36A4A" }, { code:"KEIM-9184", hex:"#B87B69" },
    { code:"KEIM-9186", hex:"#BD8B7A" }, { code:"KEIM-9263", hex:"#8E775C" }, { code:"KEIM-9330", hex:"#CCB886" },
    { code:"KEIM-9187", hex:"#C59D8B" }, { code:"KEIM-9265", hex:"#A69272" }, { code:"KEIM-9332", hex:"#D4C59F" },
    { code:"KEIM-9190", hex:"#D4B2A4" }, { code:"KEIM-9268", hex:"#BEAB8D" }, { code:"KEIM-9335", hex:"#E1D9C1" },
    { code:"KEIM-9192", hex:"#DAC1B5" }, { code:"KEIM-9271", hex:"#CEBFA4" }, { code:"KEIM-9337", hex:"#E9E4D3" },
    { code:"KEIM-9195", hex:"#E7D7CC" }, { code:"KEIM-9274", hex:"#E0D1BC" }, { code:"KEIM-9339", hex:"#EEE8DB" },
    { code:"KEIM-9197", hex:"#E8E0D8" }, { code:"KEIM-9276", hex:"#E9DCC9" }, { code:"KEIM-9345", hex:"#A19673" },
    { code:"KEIM-9200", hex:"#6F4B45" }, { code:"KEIM-9283", hex:"#857460" }, { code:"KEIM-9348", hex:"#B4AA8B" },
    { code:"KEIM-9201", hex:"#7F5E59" }, { code:"KEIM-9285", hex:"#A3927C" }, { code:"KEIM-9351", hex:"#C7BB9D" },
    { code:"KEIM-9203", hex:"#8F726E" }, { code:"KEIM-9288", hex:"#B6A691" }, { code:"KEIM-9354", hex:"#D9CFB8" },
    { code:"KEIM-9206", hex:"#AA928A" }, { code:"KEIM-9292", hex:"#CFC3B3" }, { code:"KEIM-9357", hex:"#E8E2D3" },
    { code:"KEIM-9210", hex:"#C7B3AB" }, { code:"KEIM-9294", hex:"#DBD2C5" }, { code:"KEIM-9367", hex:"#ABA169" },
    { code:"KEIM-9213", hex:"#D9CBC2" }, { code:"KEIM-9295", hex:"#E1D7CA" }, { code:"KEIM-9369", hex:"#BDB480" },
    { code:"KEIM-9215", hex:"#E0D5CD" }, { code:"KEIM-9296", hex:"#E3DCD2" }, { code:"KEIM-9373", hex:"#D1CBA4" },
    { code:"KEIM-9217", hex:"#E5E0D8" }, { code:"KEIM-9298", hex:"#ECE5DA" }, { code:"KEIM-9375", hex:"#E1DBBC" },
    { code:"KEIM-9225", hex:"#998985" }, { code:"KEIM-9304", hex:"#9A8C78" }, { code:"KEIM-9382", hex:"#6B6D61" },
    { code:"KEIM-9229", hex:"#BEB0AF" }, { code:"KEIM-9307", hex:"#AAA091" }, { code:"KEIM-9383", hex:"#7A7F6B" },
    { code:"KEIM-9233", hex:"#D3C9CA" }, { code:"KEIM-9310", hex:"#C1B8A6" }, { code:"KEIM-9385", hex:"#94987F" },
    { code:"KEIM-9243", hex:"#9D7E5C" }, { code:"KEIM-9312", hex:"#CFC7B6" }, { code:"KEIM-9389", hex:"#AFB59C" },
    { code:"KEIM-9245", hex:"#B3946F" }, { code:"KEIM-9314", hex:"#DBD3C5" }, { code:"KEIM-9392", hex:"#C9CBB8" },
    { code:"KEIM-9248", hex:"#C1A27F" }, { code:"KEIM-9317", hex:"#E8E3D8" }, { code:"KEIM-9395", hex:"#DADACB" },
    { code:"KEIM-9249", hex:"#C3AA8D" }, { code:"KEIM-9323", hex:"#85795C" }, { code:"KEIM-9396", hex:"#E3E1D4" },
    { code:"KEIM-9251", hex:"#D3BFA1" }, { code:"KEIM-9325", hex:"#A58F5E" }, { code:"KEIM-9398", hex:"#E8E5DC" },
    { code:"KEIM-9253", hex:"#DAC6AE" }, { code:"KEIM-9328", hex:"#C3A460" }, { code:"KEIM-9402", hex:"#627763" },
    { code:"KEIM-9255", hex:"#E2D5C2" }, { code:"KEIM-9329", hex:"#CDB374" }, { code:"KEIM-9406", hex:"#909F84" },
    { code:"KEIM-9410", hex:"#B4BBA4" }, { code:"KEIM-9494", hex:"#D5D2CF" }, { code:"KEIM-9572", hex:"#CAC3BF" },
    { code:"KEIM-9412", hex:"#C5CAB6" }, { code:"KEIM-9497", hex:"#E0DFDA" }, { code:"KEIM-9574", hex:"#DAD3D1" },
    { code:"KEIM-9430", hex:"#98BDAA" }, { code:"KEIM-9505", hex:"#8E8F8A" }, { code:"KEIM-9576", hex:"#E2DBD6" },
    { code:"KEIM-9432", hex:"#B6CEC1" }, { code:"KEIM-9510", hex:"#B6BAB6" }, { code:"KEIM-9582", hex:"#757676" },
    { code:"KEIM-9435", hex:"#CBD9CB" }, { code:"KEIM-9514", hex:"#D0D0CC" }, { code:"KEIM-9585", hex:"#969492" },
    { code:"KEIM-9436", hex:"#DAE1D6" }, { code:"KEIM-9516", hex:"#DCDBD8" }, { code:"KEIM-9590", hex:"#BAB7B2" },
    { code:"KEIM-9437", hex:"#E7E6DC" }, { code:"KEIM-9523", hex:"#86837A" }, { code:"KEIM-9592", hex:"#C9C7C4" },
    { code:"KEIM-9448", hex:"#8AB1B4" }, { code:"KEIM-9525", hex:"#A09B8C" }, { code:"KEIM-9595", hex:"#DADBD8" },
    { code:"KEIM-9451", hex:"#AAC2C2" }, { code:"KEIM-9526", hex:"#A39B89" }, { code:"KEIM-9870", hex:"#E9E6E0" },
    { code:"KEIM-9454", hex:"#C5D3D0" }, { code:"KEIM-9529", hex:"#BAB3A0" },
    { code:"KEIM-9456", hex:"#D5DBD5" }, { code:"KEIM-9531", hex:"#C6C0AF" },
    { code:"KEIM-9457", hex:"#DEE0D8" }, { code:"KEIM-9533", hex:"#D6CDBE" },
    { code:"KEIM-9463", hex:"#6A8186" }, { code:"KEIM-9536", hex:"#E2DCCD" },
    { code:"KEIM-9466", hex:"#8E9898" }, { code:"KEIM-9541", hex:"#615C54" },
    { code:"KEIM-9468", hex:"#A3A8A6" }, { code:"KEIM-9543", hex:"#817C75" },
    { code:"KEIM-9471", hex:"#BEBDB7" }, { code:"KEIM-9546", hex:"#9E968B" },
    { code:"KEIM-9473", hex:"#D0CFC8" }, { code:"KEIM-9550", hex:"#BDB7AF" },
    { code:"KEIM-9475", hex:"#D8D6CE" }, { code:"KEIM-9552", hex:"#CDC6BD" },
    { code:"KEIM-9477", hex:"#E7E4DD" }, { code:"KEIM-9554", hex:"#D4CEC3" },
    { code:"KEIM-9482", hex:"#647186" }, { code:"KEIM-9555", hex:"#D8D2C6" },
    { code:"KEIM-9486", hex:"#8F99A8" }, { code:"KEIM-9556", hex:"#E2DCD1" },
    { code:"KEIM-9488", hex:"#A7AEB9" }, { code:"KEIM-9564", hex:"#918680" },
    { code:"KEIM-9490", hex:"#B9BEC3" }, { code:"KEIM-9567", hex:"#A9A09A" },
    { code:"KEIM-9493", hex:"#C8CBCC" }, { code:"KEIM-9569", hex:"#BBB3AF" },
  ].map(c => ({ ...c, name: c.code }));

  const KEIM_EDITION_HISTORISCH = [
    { code:"KEIM-50001", hex:"#B1B0AA" }, { code:"KEIM-50002", hex:"#BABBB9" }, { code:"KEIM-50003", hex:"#BCBBB5" },
    { code:"KEIM-50004", hex:"#948B7C" }, { code:"KEIM-50005", hex:"#A49B90" }, { code:"KEIM-50006", hex:"#C1B9AE" },
    { code:"KEIM-50007", hex:"#C8BFB5" }, { code:"KEIM-50008", hex:"#D2C9BD" }, { code:"KEIM-50009", hex:"#A29585" },
    { code:"KEIM-50010", hex:"#BBB1A4" }, { code:"KEIM-50011", hex:"#C3B8A5" }, { code:"KEIM-50012", hex:"#C7BFAF" },
    { code:"KEIM-50013", hex:"#D4C9B7" }, { code:"KEIM-50014", hex:"#A8A28F" }, { code:"KEIM-50015", hex:"#ADA48F" },
    { code:"KEIM-50016", hex:"#B7B1A1" }, { code:"KEIM-50017", hex:"#B9AC96" }, { code:"KEIM-50018", hex:"#C4B396" },
    { code:"KEIM-50019", hex:"#CCBEA7" }, { code:"KEIM-50020", hex:"#DED1BE" }, { code:"KEIM-50021", hex:"#B59673" },
    { code:"KEIM-50022", hex:"#CFB694" }, { code:"KEIM-50023", hex:"#DEC4A0" }, { code:"KEIM-50024", hex:"#9A7950" },
    { code:"KEIM-50025", hex:"#AA7D4F" }, { code:"KEIM-50026", hex:"#CA9F6C" }, { code:"KEIM-50027", hex:"#C7A378" },
    { code:"KEIM-50028", hex:"#D2AD7E" }, { code:"KEIM-50029", hex:"#7C645B" }, { code:"KEIM-50030", hex:"#8A6B63" },
  ].map(c => ({ ...c, name: c.code }));

  const KEIM_MONOCHROME = [
    { code:"KEIM-O-9001", hex:"#EAE37C" }, { code:"KEIM-S-9001", hex:"#EDE88B" },
    { code:"KEIM-O-9002", hex:"#C9923A" }, { code:"KEIM-S-9002", hex:"#D59E40" },
    { code:"KEIM-O-9003", hex:"#914433" }, { code:"KEIM-S-9003", hex:"#9F4934" },
    { code:"KEIM-O-9004", hex:"#6D654E" }, { code:"KEIM-S-9004", hex:"#746B50" },
    { code:"KEIM-O-9005", hex:"#587850" }, { code:"KEIM-S-9005", hex:"#69865E" },
    { code:"KEIM-O-9006", hex:"#4567C8" }, { code:"KEIM-S-9006", hex:"#5F7ECE" },
    { code:"KEIM-O-9007", hex:"#6C463B" }, { code:"KEIM-S-9007", hex:"#724B3E" },
    { code:"KEIM-O-9008", hex:"#444142" }, { code:"KEIM-S-9008", hex:"#524E4F" },
    { code:"KEIM-O-9009", hex:"#0079B3" }, { code:"KEIM-S-9009", hex:"#2F8FBA" },
    { code:"KEIM-O-9010", hex:"#814743" }, { code:"KEIM-S-9010", hex:"#8E4841" },
    { code:"KEIM-O-9011", hex:"#CB7D2F" }, { code:"KEIM-S-9011", hex:"#D88D37" },
    { code:"KEIM-O-9012", hex:"#3F9961" }, { code:"KEIM-S-9012", hex:"#5BA973" },
    { code:"KEIM-O-9018", hex:"#F0E026" }, { code:"KEIM-O-9019", hex:"#D53F30" },
    { code:"KEIM-O-9020", hex:"#00AFBC" }, { code:"KEIM-O-9021", hex:"#3B3B3C" },
    { code:"KEIM-O-1001", hex:"#E7C059" }, { code:"KEIM-O-1002", hex:"#D7D6D6" },
  ].map(c => ({ ...c, name: c.code }));

  const KEIM_NATURSTEIN = [
    { code:"KEIM-S003", hex:"#B89564" }, { code:"KEIM-S087", hex:"#9E877A" }, { code:"KEIM-S165", hex:"#ABA491" },
    { code:"KEIM-S005", hex:"#AF9671" }, { code:"KEIM-S089", hex:"#B19A8E" }, { code:"KEIM-S168", hex:"#D0CAB6" },
    { code:"KEIM-S007", hex:"#AF9C7D" }, { code:"KEIM-S103", hex:"#A48C6B" }, { code:"KEIM-S183", hex:"#7D7B78" },
    { code:"KEIM-S017", hex:"#B99F7F" }, { code:"KEIM-S105", hex:"#B19E83" }, { code:"KEIM-S187", hex:"#AEA79C" },
    { code:"KEIM-S019", hex:"#BFA787" }, { code:"KEIM-S107", hex:"#B7A586" }, { code:"KEIM-S189", hex:"#C2BDAF" },
    { code:"KEIM-S041", hex:"#A76653" }, { code:"KEIM-S109", hex:"#CBB99C" }, { code:"KEIM-S193", hex:"#8F8A7C" },
    { code:"KEIM-S043", hex:"#A06850" }, { code:"KEIM-S110", hex:"#837362" }, { code:"KEIM-S195", hex:"#9B978B" },
    { code:"KEIM-S049", hex:"#C48D66" }, { code:"KEIM-S112", hex:"#9D8C77" }, { code:"KEIM-S198", hex:"#B1A894" },
    { code:"KEIM-S053", hex:"#946A59" }, { code:"KEIM-S113", hex:"#9B8C76" }, { code:"KEIM-S199", hex:"#B5AF9E" },
    { code:"KEIM-S057", hex:"#9E7866" }, { code:"KEIM-S114", hex:"#B2A28F" },
    { code:"KEIM-S059", hex:"#9B7869" }, { code:"KEIM-S115", hex:"#B39F85" },
    { code:"KEIM-S063", hex:"#B18977" }, { code:"KEIM-S117", hex:"#B5A792" },
    { code:"KEIM-S065", hex:"#B2917F" }, { code:"KEIM-S119", hex:"#C9BAA4" },
    { code:"KEIM-S066", hex:"#B89988" }, { code:"KEIM-S122", hex:"#D2C6B6" },
    { code:"KEIM-S068", hex:"#B58E75" }, { code:"KEIM-S143", hex:"#A08F71" },
    { code:"KEIM-S070", hex:"#CBA791" }, { code:"KEIM-S145", hex:"#958D76" },
    { code:"KEIM-S071", hex:"#886556" }, { code:"KEIM-S147", hex:"#9F9472" },
    { code:"KEIM-S073", hex:"#876A58" }, { code:"KEIM-S148", hex:"#C0B18B" },
    { code:"KEIM-S075", hex:"#8F705C" }, { code:"KEIM-S149", hex:"#A59577" },
    { code:"KEIM-S079", hex:"#A7886D" }, { code:"KEIM-S153", hex:"#7C8274" },
    { code:"KEIM-S080", hex:"#988D89" }, { code:"KEIM-S155", hex:"#7D7C70" },
    { code:"KEIM-S081", hex:"#88736E" }, { code:"KEIM-S157", hex:"#8D8D7F" },
    { code:"KEIM-S083", hex:"#907C6F" }, { code:"KEIM-S161", hex:"#9A917C" },
    { code:"KEIM-S085", hex:"#9E8072" }, { code:"KEIM-S163", hex:"#ABA38E" },
  ].map(c => ({ ...c, name: c.code }));

  const SECTIONS = [
    { id: 'ral',                  label: 'RAL Klassiek',                      colors: RAL,                     mucha: false },
    { id: 'copperant-mucha',      label: 'Mucha – de vier seizoenen',         colors: COPPERANT_MUCHA,         mucha: true  },
    { id: 'copperant-traditionals', label: 'Copperant Traditionals',          colors: COPPERANT_TRAD,          mucha: false },
    { id: 'copperant-wittinten',  label: 'Copperant Wittinten',               colors: COPPERANT_WIT,           mucha: false },
    { id: 'copperant-hout',       label: 'Copperant Transparante houtkleuren', colors: COPPERANT_HOUT,         mucha: false, transparantOnly: true },
    { id: 'keim-avantgarde',      label: 'KEIM Avantgarde',                   colors: KEIM_AVANTGARDE,         mucha: false },
    { id: 'keim-exclusiv',        label: 'KEIM Palette Exclusiv',             colors: KEIM_PALETTE_EXCLUSIV,   mucha: false },
    { id: 'keim-historisch',      label: 'KEIM Edition Historisch',           colors: KEIM_EDITION_HISTORISCH, mucha: false },
    { id: 'keim-monochrome',      label: 'KEIM Monochrome',                   colors: KEIM_MONOCHROME,         mucha: false },
    { id: 'keim-naturstein',      label: 'KEIM Natursteintönen',              colors: KEIM_NATURSTEIN,         mucha: false },
  ];

  // ─────────────────────────────────────────────
  //  STATE
  // ─────────────────────────────────────────────
  let selectedColor = null;
  const DEFAULT_COLOR_CODE = '__default__';

  // ─────────────────────────────────────────────
  //  RENDER
  // ─────────────────────────────────────────────
  function renderGrid() {
    const container = document.getElementById('ccp-grid-container');
    if (!container) return;

    const collectionVal = document.getElementById('ccp-collection-select').value;
    const query = document.getElementById('ccp-search').value.trim().toLowerCase();
    const btn = document.getElementById('ccp-open-btn');
    const isTransparant = btn && btn.dataset.transparant === 'true';
    const houtOnly = btn && btn.dataset.houtOnly === 'true';
    const defaultColorLabel = btn ? btn.dataset.defaultColor : '';

    container.innerHTML = '';
    let total = 0;

    if (defaultColorLabel && (!query || defaultColorLabel.toLowerCase().includes(query))) {
      const defaultColor = { code: DEFAULT_COLOR_CODE, name: defaultColorLabel, hex: null, isDefault: true };
      const sectionEl = document.createElement('div');
      const titleEl = document.createElement('div');
      titleEl.className = 'ccp-section-title';
      titleEl.textContent = 'Standaardkleur';
      sectionEl.appendChild(titleEl);
      sectionEl.appendChild(buildGrid([defaultColor]));
      container.appendChild(sectionEl);
      total += 1;
    }

    let availableSections;
    if (houtOnly) {
      availableSections = SECTIONS.filter(s => s.id === 'copperant-hout');
    } else {
      availableSections = SECTIONS.filter(s => !s.transparantOnly || isTransparant);
    }
    const sections = collectionVal === 'all'
      ? availableSections
      : availableSections.filter(s => s.id === collectionVal);

    sections.forEach(section => {
      let colors = section.colors.filter(c =>
        !query ||
        (c.name && c.name.toLowerCase().includes(query)) ||
        c.code.toLowerCase().includes(query) ||
        (c.sub && c.sub.toLowerCase().includes(query))
      );
      if (!colors.length) return;

      total += colors.length;

      const sectionEl = document.createElement('div');

      const titleEl = document.createElement('div');
      titleEl.className = 'ccp-section-title';
      titleEl.innerHTML = `${section.label} <span class="ccp-section-count">${colors.length} kleuren</span>`;
      sectionEl.appendChild(titleEl);

      if (section.mucha) {
        ['Lente','Zomer','Herfst','Winter'].forEach(season => {
          const group = colors.filter(c => c.sub === season);
          if (!group.length) return;
          const subTitle = document.createElement('div');
          subTitle.className = 'ccp-sub-title';
          subTitle.textContent = season;
          sectionEl.appendChild(subTitle);
          sectionEl.appendChild(buildGrid(group));
        });
      } else {
        sectionEl.appendChild(buildGrid(colors));
      }

      container.appendChild(sectionEl);
    });

    if (!total) {
      container.innerHTML = `<div class="ccp-empty">Geen kleuren gevonden voor "${query}".</div>`;
    }

    document.getElementById('ccp-count').textContent = `${total} kleuren`;
  }

  function buildGrid(colors) {
    const grid = document.createElement('div');
    grid.className = 'ccp-grid';
    colors.forEach(c => grid.appendChild(buildChip(c)));
    return grid;
  }

  function buildChip(color) {
    const chip = document.createElement('div');
    chip.className = 'ccp-chip'
      + (color.isDefault ? ' ccp-chip--default' : '')
      + (selectedColor && selectedColor.code === color.code ? ' is-selected' : '');
    chip.dataset.code = color.code;
    chip.setAttribute('role', 'button');
    chip.setAttribute('aria-label', color.isDefault ? color.name : `${color.code} ${color.name}`);
    chip.setAttribute('tabindex', '0');
    chip.innerHTML = color.isDefault
      ? `
        <div class="ccp-chip__swatch-wrap">
          <div class="ccp-chip__swatch ccp-chip__swatch--default"></div>
        </div>
        <div class="ccp-chip__info">
          <div class="ccp-chip__name">${color.name}</div>
        </div>
      `
      : `
        <div class="ccp-chip__swatch-wrap">
          <div class="ccp-chip__swatch" style="background:${color.hex};"></div>
        </div>
        <div class="ccp-chip__info">
          <div class="ccp-chip__code">${color.code}</div>
          <div class="ccp-chip__name">${color.name}</div>
        </div>
      `;
    chip.addEventListener('click', () => { selectColor(color); if (!color.isDefault) showZoom(chip, color); });
    chip.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') selectColor(color); });
    return chip;
  }

  function showZoom(chipEl, color) {
    let card = document.getElementById('ccp-zoom-card');
    if (!card) {
      card = document.createElement('div');
      card.id = 'ccp-zoom-card';
      card.className = 'ccp-zoom-card';
      card.addEventListener('click', () => card.classList.remove('visible'));
      document.body.appendChild(card);
    }

    card.innerHTML = `
      <div class="ccp-zoom-card__swatch" style="background:${color.hex};"></div>
      <div class="ccp-zoom-card__info">
        <div class="ccp-zoom-card__code">${color.code}</div>
        <div class="ccp-zoom-card__name">${color.name}</div>
      </div>
    `;

    const rect = chipEl.getBoundingClientRect();
    const cardW = 260;
    const cardH = 320;

    let left = rect.left + rect.width / 2 - cardW / 2;
    let top  = rect.top - cardH - 12;

    left = Math.max(8, Math.min(left, window.innerWidth - cardW - 8));
    if (top < 8) top = rect.bottom + 12;

    card.style.left = left + 'px';
    card.style.top  = top  + 'px';
    card.classList.add('visible');

    clearTimeout(card._timer);
    card._timer = setTimeout(() => card.classList.remove('visible'), 2200);
  }

  function selectColor(color) {
    selectedColor = color;

    // Chips visueel bijwerken
    document.querySelectorAll('.ccp-chip').forEach(c => {
      c.classList.toggle('is-selected', c.dataset.code === color.code);
    });

    // Footer preview tonen
    const preview = document.getElementById('ccp-selected-preview');
    const swatch  = document.getElementById('ccp-preview-swatch');
    const code    = document.getElementById('ccp-preview-code');
    const name    = document.getElementById('ccp-preview-name');
    if (preview) {
      preview.style.visibility = 'visible';
      swatch.classList.toggle('ccp-preview-swatch--default', !!color.isDefault);
      swatch.style.background = color.isDefault ? '' : color.hex;
      code.textContent = color.isDefault ? '' : color.code;
      name.textContent = color.name;
    }

    // "Aan winkelwagen toevoegen" knop in modal activeren
    const addBtn = document.getElementById('ccp-add-to-cart');
    if (addBtn) addBtn.disabled = false;
  }

  // ─────────────────────────────────────────────
  //  OPEN / CLOSE
  // ─────────────────────────────────────────────
  let checkoutMode = false;

  function openPicker(forCheckout) {
    checkoutMode = !!forCheckout;
    const overlay = document.getElementById('color-picker-overlay');
    if (!overlay) return;
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderGrid();
    const addBtn = document.getElementById('ccp-add-to-cart');
    if (addBtn) addBtn.textContent = 'Kleur bevestigen';
    setTimeout(() => document.getElementById('ccp-search')?.focus(), 100);
  }

  function closePicker() {
    const overlay = document.getElementById('color-picker-overlay');
    if (!overlay) return;
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    const zoom = document.getElementById('ccp-zoom-card');
    if (zoom) zoom.classList.remove('visible');
  }

  // ─────────────────────────────────────────────
  //  KLEUR BEVESTIGEN (vanuit de modal)
  //  Voegt niets zelf toe aan de cart — dat doet de native
  //  "Aan winkelwagen toevoegen"-knop op de productpagina, die de kleur
  //  als line item property meestuurt (zie setLineItemProperty /
  //  updateTriggerButton). Zo komt het product maar één keer in de cart.
  // ─────────────────────────────────────────────
  function getAddToCartForm() {
    // Er kan meer dan één <form action="/cart/add"> op de pagina staan
    // (bv. de onzichtbare Shop Pay installment-form). Ga uit van de echte
    // submit-knop, die al bewezen uniek is in dit bestand.
    const submitBtn = document.querySelector('.product-form__submit');
    return submitBtn ? submitBtn.closest('form') : null;
  }

  function confirmColorSelection() {
    if (!selectedColor) return;

    closePicker();
    updateTriggerButton(selectedColor);
  }

  function showModalError(msg) {
    let err = document.getElementById('ccp-modal-error');
    if (!err) {
      err = document.createElement('div');
      err.id = 'ccp-modal-error';
      err.className = 'ccp-modal-error';
      document.querySelector('.ccp-footer')?.prepend(err);
    }
    err.textContent = msg;
    err.hidden = false;
    setTimeout(() => { if (err) err.hidden = true; }, 3500);
  }

  // ─────────────────────────────────────────────
  //  TRIGGER BUTTON + BLOKKEER NATIVE ADD-TO-CART
  // ─────────────────────────────────────────────
  function injectTriggerButton() {
    // Dawn: variant picker is .product-form__controls of .variant-selects
    const variantPicker = document.querySelector(
      '.product-form__controls, .variant-selects, .variant-radios, .product-form .product-form__input'
    );
    if (!variantPicker) return;

    const wrap = document.createElement('div');
    wrap.className = 'ccp-trigger-wrap';
    wrap.id = 'ccp-trigger-wrap';
    wrap.innerHTML = `
      <button type="button" class="ccp-trigger" id="ccp-open-btn" aria-haspopup="dialog">
        <span class="ccp-trigger-swatch" id="ccp-trigger-swatch"></span>
        <div class="ccp-trigger-text">
          <span class="ccp-trigger-label">Kies jouw kleur</span>
          <span class="ccp-trigger-hint">Verplicht – kies een RAL of Copperant kleur</span>
        </div>
        <span class="ccp-trigger-value" id="ccp-trigger-value"></span>
        <svg class="ccp-trigger-arrow" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>
    `;

    variantPicker.parentNode.insertBefore(wrap, variantPicker.nextSibling);

    document.getElementById('ccp-open-btn').addEventListener('click', openPicker);

    // ── Blokkeer de native "Aan winkelwagen toevoegen" knop ──
    // Dawn's buy-button heeft de class .product-form__submit
    blockNativeAddToCart();
  }

  function blockNativeAddToCart() {
    // Wacht even totdat Dawn de knop heeft gerenderd
    const tryBlock = (attempts = 0) => {
      const submitBtn = document.querySelector(
        '.product-form__submit, button[name="add"], [data-product-form] button[type="submit"]'
      );

      if (!submitBtn) {
        if (attempts < 10) setTimeout(() => tryBlock(attempts + 1), 300);
        return;
      }

      // Disable de knop totdat een kleur is gekozen
      submitBtn.disabled = true;
      submitBtn.setAttribute('title', 'Kies eerst een kleur');
      submitBtn.classList.add('ccp-blocked');

      // Onderschep klik-pogingen met uitleg
      submitBtn.addEventListener('click', (e) => {
        if (!selectedColor) {
          e.preventDefault();
          e.stopPropagation();
          // Scroll naar de kleurkiezer en highlight hem
          const trigger = document.getElementById('ccp-open-btn');
          if (trigger) {
            trigger.scrollIntoView({ behavior: 'smooth', block: 'center' });
            trigger.classList.add('ccp-trigger--attention');
            setTimeout(() => trigger.classList.remove('ccp-trigger--attention'), 1500);
          }
        }
      }, true);
    };

    tryBlock();
  }

  function updateTriggerButton(color) {
    const swatch = document.getElementById('ccp-trigger-swatch');
    const value  = document.getElementById('ccp-trigger-value');
    const hint   = document.querySelector('.ccp-trigger-hint');
    const trigger = document.getElementById('ccp-open-btn');

    if (swatch) {
      swatch.classList.toggle('ccp-trigger-swatch--default', !!color.isDefault);
      swatch.style.background = color.isDefault ? '' : color.hex;
    }
    if (value)  value.textContent = color.isDefault ? color.name : `${color.code} – ${color.name}`;
    if (hint)   hint.textContent = 'Kleur gekozen – klik om te wijzigen';
    if (trigger) trigger.classList.add('ccp-trigger--chosen');

    // Deblokkeer native add-to-cart knop nu er een kleur gekozen is
    // (niet meer nodig want modal doet de add-to-cart, maar als fallback)
    const submitBtn = document.querySelector(
      '.product-form__submit, button[name="add"], [data-product-form] button[type="submit"]'
    );
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('title');
      submitBtn.classList.remove('ccp-blocked');
      // Sla kleur ook op als hidden line item properties (fallback voor native form submit)
      setLineItemProperty('Kleurnaam', color.name);
      if (color.isDefault) {
        clearLineItemProperty('Kleurcode');
        clearLineItemProperty('Hex');
      } else {
        setLineItemProperty('Kleurcode', color.code);
        setLineItemProperty('Hex', color.hex);
      }
    }
  }

  function setLineItemProperty(key, value) {
    const form = getAddToCartForm();
    if (!form) return;
    const inputName = `properties[${key}]`;
    let input = form.querySelector(`input[name="${inputName}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      form.appendChild(input);
    }
    input.value = value;
  }

  function clearLineItemProperty(key) {
    const form = getAddToCartForm();
    if (!form) return;
    const input = form.querySelector(`input[name="properties[${key}]"]`);
    if (input) input.remove();
  }

  // ─────────────────────────────────────────────
  //  EVENT LISTENERS
  // ─────────────────────────────────────────────
  function bindEvents() {
    document.getElementById('ccp-close')?.addEventListener('click', closePicker);
    document.getElementById('ccp-cancel')?.addEventListener('click', closePicker);
    document.getElementById('ccp-add-to-cart')?.addEventListener('click', confirmColorSelection);

    document.getElementById('ccp-collection-select')?.addEventListener('change', renderGrid);
    document.getElementById('ccp-search')?.addEventListener('input', renderGrid);

    document.getElementById('color-picker-overlay')?.addEventListener('click', e => {
      if (e.target === e.currentTarget) closePicker();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && document.getElementById('color-picker-overlay')?.classList.contains('open')) {
        closePicker();
      }
    });
  }

  // ─────────────────────────────────────────────
  //  INIT
  // ─────────────────────────────────────────────
  function init() {
    // Verplaats overlay naar <body> zodat Dawn's CSS transforms hem niet verstoren.
    // position:fixed werkt anders als een voorouder een transform heeft.
    const overlay = document.getElementById('color-picker-overlay');
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    bindEvents();
    blockNativeAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  async function addToCartAndCheckout() {
    if (!selectedColor) {
      openPicker(true);
      return;
    }
    const form = getAddToCartForm();
    if (!form) { window.location.href = '/checkout'; return; }
    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput ? variantInput.value : null;
    if (!variantId) { openPicker(); return; }
    const quantityInput = form.querySelector('[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    const properties = { 'Kleurnaam': selectedColor.name };
    if (!selectedColor.isDefault) {
      properties['Kleurcode'] = selectedColor.code;
      properties['Hex'] = selectedColor.hex;
    }
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties
        })
      });
      if (!response.ok) throw new Error('Cart error');
      window.location.href = '/checkout';
    } catch (err) {
      window.location.href = '/checkout';
    }
  }

  window.CopperantColorPicker = { open: openPicker, close: closePicker, addToCartAndCheckout: addToCartAndCheckout, hasColor: () => !!selectedColor };

})();// v2